import { IAreaTypeList } from './i-area-type-list';
import { AreaType } from './area-type';

export const areaTypeList: IAreaTypeList[] = [
    { id: AreaType.default, text: 'По умолчанию' },
    // {id: AreaType.layoutLinear, text: 'Линейная компоновка'},
    { id: AreaType.layout2D, text: '2D компоновка' },
];
